import React from "react";
import SeoHeader from "../../components/ui/layout/SeoHeader";
import iconSmartPbx from "../../images/icons/icon-smart-pbx.svg";
import SmartPbxGraph from "../../images/graph-smartpbx.svg";
import { FaCheckCircle } from "react-icons/fa";
import PageHeroSection from "../../components/ui/PageSections/PageHeroSection";
import PrimaryButton from "../../components/ui/inputs/buttons/Button";
import StyledTitle from "../../components/ui/StyledTitle";
import Section from "../../components/ui/Section";
import ContactUsBanner from "../../components/ui/PageSections/ContactUsBanner";

const SmartpbxPageTemplate = ({ pageContext, translations }) => {
	const smartPbxLink = process.env.GATSBY_SMARTPBX_EXTERNAL_LINK;

	return (
		<div className="flex flex-col gap-8">
			<div className="container mx-auto flex flex-col gap-4 pb-20">
				<PageHeroSection
					heroIcon={iconSmartPbx}
					heroTitle={
						translations["SmartPbxMainTitle"] ? translations["SmartPbxMainTitle"] : pageContext.h1Title
					}
					subtitle={translations["SmartPbxSubtitle"] ? translations["SmartPbxSubtitle"] : pageContext.h2Title}
					intro={translations["SmartPbxIntro"]}
				/>
				<div className="relative flex flex-col lg:md:w-full w-full px-4 md:px-28 xl:px-0">
					<PrimaryButton>
						<a href={smartPbxLink} target="_blank" rel="noopener noreferrer">
							{translations["SmartPbxHeroButtontext"]}
						</a>
					</PrimaryButton>
				</div>
			</div>

			<Section>
				<section className="grid grid-cols-1 xl:grid-cols-2 gap-8 text-ipxon-black w-full">
					<div className="flex flex-col gap-8">
						<StyledTitle
							titleColor="text-ipxon-black"
							titleSize="text-3xl"
							titleText={translations["SmartPbxContentTitleOne"]}
							titleText2={translations["SmartPbxContentTitleTwo"]}
							subtitleText={translations["SmartPbxContentSmallTitle"]}
							labelText=""
							titleWeight="font-normal"
						/>

						<p className="text-base xl:w-5/6">{translations["SmartPbxContent"]}</p>
						<div className="flex flex-col gap-2">
							<h4 className="text-base font-bold">{translations["SmartPbxContentSubtitle"]}</h4>
							<ul className="capitalize marker:text-ipxon-magenta flex flex-col gap-1">
								<li className="flex items-center gap-2">
									<FaCheckCircle className="h-3 w-3 text-[#B9BFC1]" />
									{translations["SmartPbxContentBulletOne"]}
								</li>
								<li className="flex items-center gap-2">
									<FaCheckCircle className="h-3 w-3 text-[#B9BFC1]" />
									{translations["SmartPbxContentBulletTwo"]}
								</li>
								<li className="flex items-center gap-2">
									<FaCheckCircle className="h-3 w-3 text-[#B9BFC1]" />
									{translations["SmartPbxContentBulletThree"]}
								</li>
							</ul>
						</div>
					</div>
					<img className="w-full max-w-lg m-auto" src={SmartPbxGraph} alt="Smart pbx svg graphic" />
				</section>
			</Section>
			<Section color="transparent">
				<ContactUsBanner
					title={translations["SmartPbxContactUsBannerTitle"]}
					subtitle={translations["SmartPbxContactUsBannerText"]}
					contactText={translations["ContactUsBannerButtonText"]}
				/>
			</Section>
		</div>
	);
};

export const Head = ({ pageContext }) => <SeoHeader pageContext={pageContext} />;

export default SmartpbxPageTemplate;
